module.exports = __webpack_public_path__ + "static/img/7.e40f222.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/7.png
// module id = MCzw
// module chunks = 0